import ModerateInvoice from "./ModerateInvoice";

export default ModerateInvoice;
